<app-breadcrumb [title]="'Login'" [breadcrumb]="'Login'"></app-breadcrumb>
<!-- section start -->
<section class="login-page section-b-space">
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <h3>Inicio de sesión</h3>
                <div class="theme-card" >
                    <form class="theme-form"  [formGroup]="loginForm">
                        <div class="form-group">
                            <div class="d-flex">
                                <label for="email">Correo electrónico</label> &nbsp;
                                <label class="text-success" *ngIf="correoVerificado">*Correo verificado, inicia sesión para continuar</label>
                            </div>
                            <input formControlName="username"  type="text" class="form-control" id="email" placeholder="Correo electrónico" required="">
                        </div>
                        <div class="form-group">
                            <label for="review">Contraseña</label>
                            <div class="d-flex">
                                <input formControlName="password" [type]="hide ? 'password' : 'text'" class="form-control"
                                maxlength="16"
                                id="password" placeholder="Ingresa tu contraseña" required="">
                                <span class="toggle-password" [ngClass]="{'show-password': !hide, 'hide-password': hide}" (click)="togglePassword()"></span>
                            </div>
                        </div>
                        <button class="btn btn-solid" (click)="onSubmit()">Iniciar sesión</button>
                        <a class="pull-right" [routerLink]="['/pages/forget/password']"><span class="olvidoContrasena">¿Olvidaste tu contraseña?</span></a>
                    </form>
                    

                </div>
            </div>
            <div class="col-lg-6 right-login">
                <h3>Nuevo usuario</h3>
                <div class="theme-card authentication-right">
                    <h6 class="title-font">Crear cuenta</h6>
                    <p>Regístrese para obtener una cuenta gratuita en nuestra tienda. Registrarse es fácil y rápido. Le permite poder hacer pedidos en nuestra tienda. Para comenzar a comprar, haga clic en registrarse.</p>
                    <button class="btn btn-solid" (click)="registrarUsuario()">Registrarse</button>
                </div>
   
            </div>
        </div>
    </div>
    <!-- <div> -->
    <div *ngIf="modalCodigo === true">
        <app-modal-codigo #modalCodigo></app-modal-codigo>
    </div>
</section>
<!--Section ends-->